import { ssoLogout } from "../../utils/sso/config";
import {
  PhotoCamera,
  Save,
  SecurityOutlined,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import styles from "../addUser/addUser.module.scss";
import PROFILE_PIC from "../../assets/images/profileImg.png";
import { useS3Upload } from "../../customHooks/S3Upload";
import { useNavigate } from "react-router-dom";
import { updateUser, updateUserPassword } from "../../store/actions";
import { DESTINATIONS } from "../../utils/common/constants";

const InitialState = {
  fullName: "",
  phoneNumber: "",
  email: "",
  imageUrl: "",
  role: "",
  status: 0,
};

const IntialPasswdState = {
  password: "",
  confirmPassword: "",
};

const EditUser = ({ user, loginUser }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [images, uploadImages] = useS3Upload();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(InitialState);
  const [passwd, setPasswd] = useState(IntialPasswdState);
  const [phoneError, setPhoneError] = useState(false);
  const [errorValues, setErrorValues] = useState({});

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  // const logout = () => {
  //   dispatch({ type: "LOGOUT_USER" });
  //   navigate("/");
  // };

  const logout = () => {
    dispatch({ type: "LOGOUT_USER" });
    ssoLogout();
  };

  useEffect(() => {
    if (user?.id) {
      setUserDetails({
        fullName: user?.fullName || "",
        phoneNumber: user?.phoneNumber?.toString() || "",
        email: user?.email || "",
        role: user?.role || "",
        status:
          typeof user?.status === "number"
            ? user?.status
            : Number(user?.status) || 0,
        imageUrl: user?.imageUrl || "",
        otp: user?.otp || 123456,
      });
    }
  }, [user]);

  const isPasswordMatched =
    passwd.confirmPassword &&
    passwd.password &&
    passwd.confirmPassword === passwd.password;

  const handleUploadFiles = async (e, key, destination) => {
    const files = e.target.files;
    if (files?.length > 0) {
      const uploadUrl = await uploadImages(key, files[0], destination);
      setUserDetails({
        ...userDetails,
        imageUrl: uploadUrl,
      });
    }
  };

  const onInputChange = (key, value = "") => {
    setUserDetails({
      ...userDetails,
      [key]: value,
    });
  };

  const onPhoneChange = (value = "") => {
    if (/^\d{0,10}$/.test(value)) {
      setUserDetails({
        ...userDetails,
        phoneNumber: value,
      });
    }
  };

  const onPhoneBlur = () => {
    setPhoneError(userDetails?.phoneNumber?.length !== 10);
  };

  const onPasswordChange = (key, value = "") => {
    setPasswd({
      ...passwd,
      [key]: value,
    });
  };

  const onChangePassword = async () => {
    const payload = {
      username: user?.phoneNumber?.toString(),
      password: passwd?.password,
    };
    dispatch(
      updateUserPassword({
        payload: payload,
        callback: {
          success: () => {
            loginUser?.id === user?.id ? logout() : navigate("/userManagement");
          },
        },
      })
    );
  };

  const onSave = async () => {
    const payload = {
      fullName: userDetails?.fullName,
      phoneNumber: userDetails?.phoneNumber,
      email: userDetails?.email,
      imageUrl: userDetails?.imageUrl,
      role: userDetails?.role,
      status: userDetails?.status,
    };

    dispatch(
      updateUser({
        payload: { ...user, ...payload },
        callback: {
          success: () => {
            loginUser?.id === user?.id ? logout() : navigate("/userManagement");
          },
        },
      })
    );
  };

  const isUnchanged =
    userDetails?.fullName === user?.fullName &&
    userDetails?.phoneNumber === user?.phoneNumber?.toString() &&
    userDetails?.email === user?.email &&
    userDetails?.imageUrl === user?.imageUrl &&
    userDetails?.role === user?.role &&
    (typeof user?.status === "number"
      ? userDetails?.status === user?.status
      : userDetails?.status === Number(user?.status));

  // imageUrl is optional; do not require it for validity
  const isValid =
    !!userDetails?.fullName &&
    userDetails?.phoneNumber?.length === 10 &&
    !!userDetails?.email &&
    !!userDetails?.role;

  const isSaveEnabledEdit = isUnchanged || !isValid;

  const handleCancel = () => {
    navigate(-1);
  };

  const handleOnBlur = (key, value) => {
    let isValid = true;
    switch (key) {
      case "password":
        isValid = value.length >= 5;
        break;
      case "confirmPassword":
        isValid = value === passwd.password;
        break;
      default:
        break;
    }
    setErrorValues((prev) => ({
      ...prev,
      [key]: isValid ? null : false,
    }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.title}>EDIT USER</div>
        <Row className={styles.profilePicRow}>
          <Col className={styles.profilePicContainer}>
            <img
              src={userDetails?.imageUrl || PROFILE_PIC}
              alt="profile pic"
              className={styles.profilePic}
            />
          </Col>
          <Col className={styles.profilePicActionContainer}>
            <div className={styles.buttonsContainer}>
              <Button
                variant="contained"
                startIcon={<PhotoCamera />}
                component="label"
                classes={{ contained: styles.button }}
              >
                Upload photo
                <input
                  onChange={(e) =>
                    handleUploadFiles(e, "userImage", DESTINATIONS.USER_DETAILS)
                  }
                  type="file"
                  accept="image/*"
                  hidden
                />
              </Button>
            </div>
            <div className={styles.picUploadInfo}>
              Allowed PNG or JPEG. Max size of 500KB.
            </div>
          </Col>
        </Row>
        <Paper elevation={2} sx={{ borderRadius: "12px" }}>
          <div className={styles.top}>
            <Col className={styles.inputWrapper}>
              <div className={styles.middleWrapper}>
                <FormControl
                  variant="outlined"
                  classes={{ root: styles.inputContainer }}
                  fullWidth
                  error={phoneError}
                >
                  <InputLabel htmlFor="outline-input-fullName">
                    USERNAME*
                  </InputLabel>
                  <OutlinedInput
                    id="outline-input-fullName"
                    classes={{ root: styles.input, input: styles.inputField }}
                    label="USERNAME*"
                    value={userDetails?.fullName}
                    onChange={(e) => onInputChange("fullName", e.target.value)}
                  />
                </FormControl>
              </div>
            </Col>
            <Col className={styles.inputWrapper}>
              <div className={styles.middleWrapper}>
                <FormControl
                  variant="outlined"
                  classes={{ root: styles.inputContainer }}
                  fullWidth
                >
                  <InputLabel htmlFor="outline-input-email">
                    EMAIL ID
                  </InputLabel>
                  <OutlinedInput
                    id="outline-input-email"
                    classes={{ root: styles.input, input: styles.inputField }}
                    label="EMAIL ID"
                    value={userDetails?.email}
                    onChange={(e) => onInputChange("email", e.target.value)}
                  />
                </FormControl>
              </div>
            </Col>
            <Col className={styles.inputWrapper}>
              <div className={styles.middleWrapper}>
                <FormControl
                  variant="outlined"
                  classes={{ root: styles.inputContainer }}
                  fullWidth
                >
                  <InputLabel htmlFor="outline-input-phone">
                    MOBILE NUMBER
                  </InputLabel>
                  <OutlinedInput
                    id="outline-input-phone"
                    classes={{ root: styles.input, input: styles.inputField }}
                    label="MOBILE NUMBER"
                    value={userDetails?.phoneNumber}
                    type="tel"
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      maxLength: 10,
                    }}
                    onChange={(e) => onPhoneChange(e.target.value)}
                    onBlur={onPhoneBlur}
                  />
                  {phoneError && (
                    <FormHelperText classes={{ root: styles.helperText }}>
                      Please enter a valid 10-digit number
                    </FormHelperText>
                  )}
                </FormControl>
              </div>
            </Col>
            <Col className={styles.inputWrapper}>
              <div className={styles.middleWrapper}>
                <FormControl
                  variant="outlined"
                  classes={{ root: styles.inputContainer }}
                  fullWidth
                >
                  <InputLabel id="label-role">ROLE*</InputLabel>
                  <Select
                    labelId="label-role"
                    id="select-role"
                    value={userDetails?.role || ""}
                    label="ROLE*"
                    classes={{ root: styles.input }}
                    onChange={(e) => onInputChange("role", e.target.value)}
                  >
                    <MenuItem value={"admin"}>admin</MenuItem>
                    <MenuItem value={"dispatcher"}>dispatcher</MenuItem>
                    <MenuItem value={"packager"}>packager</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </Col>
            <Col className={styles.inputWrapper}>
              <div className={styles.middleWrapper}>
                <FormControl
                  classes={{ root: styles.inputContainer }}
                  fullWidth
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={Number(userDetails?.status) === 1}
                        onChange={(e) =>
                          onInputChange("status", e.target.checked ? 1 : 0)
                        }
                        color="primary"
                      />
                    }
                    label={`Status: ${
                      Number(userDetails?.status) === 1 ? "Active" : "Inactive"
                    }`}
                  />
                </FormControl>
              </div>
            </Col>
          </div>
        </Paper>

        <div
          className={styles.buttonContainer}
          style={{ padding: " 0px 20px" }}
        >
          <Button
            variant="contained"
            color="error"
            classes={{ contained: styles.button }}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            onClick={onSave}
            disabled={isSaveEnabledEdit}
            variant="contained"
            startIcon={<Save />}
            style={{ color: "white" }}
            classes={{ contained: styles.button }}
          >
            Save Changes
          </Button>
        </div>

        <Paper elevation={2} sx={{ borderRadius: "12px" }}>
          <div className={styles.titlePwd}>Edit Password</div>
          <div className={styles.passwordContainer}>
            <Col className={styles.inputWrapper}>
              <div className={styles.middleWrapper}>
                <FormControl
                  variant="outlined"
                  classes={{ root: styles.inputContainer }}
                  fullWidth
                  error={!!errorValues.password}
                >
                  <InputLabel htmlFor="outlined-adornment-password">
                    Password*
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? "text" : "password"}
                    classes={{ root: styles.input, input: styles.inputField }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          classes={{ root: styles.eyeButton }}
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password*"
                    value={passwd.password}
                    onChange={(e) =>
                      onPasswordChange("password", e.target.value)
                    }
                    onBlur={() => handleOnBlur("password", passwd.password)}
                  />
                  {errorValues.password === false && (
                    <FormHelperText
                      classes={{ root: styles.helperText }}
                      style={{ color: "red" }}
                    >
                      Password must be at least 5 characters
                    </FormHelperText>
                  )}
                </FormControl>
              </div>
            </Col>
            <Col className={styles.inputWrapper}>
              <div className={styles.middleWrapper}>
                <FormControl
                  variant="outlined"
                  classes={{ root: styles.inputContainer }}
                  fullWidth
                >
                  <InputLabel htmlFor="outlined-adornment-confirm">
                    Confirm Password*
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-confirm"
                    type={showPassword ? "text" : "password"}
                    classes={{ root: styles.input, input: styles.inputField }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          classes={{ root: styles.eyeButton }}
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Confirm Password*"
                    value={passwd.confirmPassword}
                    onChange={(e) =>
                      onPasswordChange("confirmPassword", e.target.value)
                    }
                  />
                </FormControl>
              </div>
            </Col>
          </div>
          <div className={styles.buttoncontainer}>
            <Button
              onClick={onChangePassword}
              disabled={!isPasswordMatched}
              variant="contained"
              style={{ color: "white" }}
              startIcon={<SecurityOutlined />}
              classes={{ contained: styles.button }}
            >
              Change Password
            </Button>
          </div>
        </Paper>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user?.user,
    loginUser: state.login?.user,
  };
};

export default connect(mapStateToProps, null)(EditUser);
